// extracted by mini-css-extract-plugin
export default {"MainWrapper":"MainScreen_MainWrapper__-jsWt","sideWrapper":"MainScreen_sideWrapper__mw0Wg","loadingWrapper":"MainScreen_loadingWrapper__b0AIE"};